module.exports = __webpack_public_path__ + "assets/img/2022_05.fcc20d96.png";